export default postcode => {
  const postcodeRegEx = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i
  return postcodeRegEx.test(postcode)
}
